<template>
  <div>
    <div
      class="artist-list">
      <a
        v-for="item in pagination.data"
        :key="item.id"
        class="artist-list__item"
        :class="{ 'overlay disabled' : item.options.overlay }"
        href="#"
        @click.prevent="selectVocaloid(item)">
        <p class="overlay-text">{{ item.options.overlayText }}</p>
        <div
          class="artist-list__pic"
          :style="`background-image: url(/images/${item.image_path})`">
        </div>
        <div class="artist-list__name">
          <span class="artist-list__name_text">
            {{ item.name }}
          </span>
          <span
            class="c-btn__icon-check"
            :class="{ 'c-btn__icon-check--on': isActive(item.id) }">
          </span>
        </div>
        <div
          v-if="isActive(item.id)"
          class="artist-list__num">
          {{ selectedNumber(item.id) }}
        </div>
      </a>
    </div>
    <div class="c-btn-wrap">
      <a
        class="c-btn"
        href="#"
        @click.prevent="onNextClicked()">
        選択して閉じる
        <span class="c-btn__icon-arrow"></span>
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ClientVocaloidIndex',
  props: {
    remainingNumber: {
      type: Number,
      required: true,
    },
    alreadySelectedVocaloid: {
      type: Array,
      required: true,
    },
    comparableVocaloid: {
      type: Array,
      required: true,
    },
    isAddingForFeaturing: {
      type: Boolean,
      required: true,
    },
    isSelectedUserArtist: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedVocaloidIds: [],
      selectedVocaloids: [],
      itemToBeDeleted: [],
      remainingItemNumber: this.remainingNumber,
      type: '',
      variousVocaloids: {},
      vocaloid: {},
      keyword: '',
      pagination: {},
      // track which artist's vocaloids are added
      isAddingForFeaturingArtist: this.isAddingForFeaturing,
    }
  },
  mounted() {
    this.fetchVocaloids()
    if (this.alreadySelectedVocaloid.length > 0) {
      this.alreadySelectedVocaloid.forEach(vocal => {
        this.selectedVocaloidIds.push(vocal.id)
        this.selectedVocaloids.push(vocal)
      })
    }
  },
  methods: {
    async fetchVocaloids() {
      const response = await window.axios.get('/api/client/vocaloids')
      this.pagination = response.data
      const filtered = this.pagination.data.filter(vocaloid => vocaloid.display_division !== 3)
      // add an 'options' key-value pair that determines the overlay.
      this.pagination.data = filtered.map(vocaloid => {
        const unavailableRequireUserArtist = { options: { overlay: true, overlayText: 'ユーザーアーティスト選択時のみ選択可能' } }
        const unavailableMain = { options: { overlay: true, overlayText: 'メインアーティストのみ選択可能' } }
        const unavailableFeaturing = { options: { overlay: true, overlayText: 'フィーチャリングアーティストのみ選択可能' } }
        const available = { options: { overlay: false, overlayText: '' } }
        if (!this.isSelectedUserArtist && vocaloid.require_user_artist === 1) {
          return { ...vocaloid, ...unavailableRequireUserArtist }
        }
        if (this.isAddingForFeaturingArtist && vocaloid.display_division === 1) {
          return { ...vocaloid, ...unavailableMain }
        }
        if (!this.isAddingForFeaturingArtist && vocaloid.display_division === 2) {
          return { ...vocaloid, ...unavailableFeaturing }
        }
        return { ...vocaloid, ...available }
      })
      this.vocaloid = window._.first(this.pagination.data)
    },
    selectVocaloid(vocaloid) {
      const index = this.selectedVocaloidIds.indexOf(vocaloid.id)
      if (index !== -1) {
        this.selectedVocaloidIds.splice(index, 1)
        this.selectedVocaloids.splice(index, 1)
        this.remainingItemNumber += 1
        if (this.itemToBeDeleted.filter(v => v.id === vocaloid.id).length === 0) {
          this.itemToBeDeleted.push(vocaloid)
        }
      } else if (this.remainingItemNumber > 0) {
        let isVocaloidArray = false
        this.comparableVocaloid.forEach(voc => {
          if (voc?.id === vocaloid.id) isVocaloidArray = true
        })
        if (!isVocaloidArray) {
          this.selectedVocaloidIds.push(vocaloid.id)
          this.selectedVocaloids.push(vocaloid)
          this.remainingItemNumber -= 1
        }
      }
      this.$emit('is-action-performed', this.selectedVocaloids)
    },
    selectVariousVocaloid() {
      this.selectedVocaloidIds = [this.variousVocaloids.id]
      this.onNextClicked(2)
    },
    isActive(vocaloidId) {
      return this.selectedVocaloidIds.indexOf(vocaloidId) !== -1
    },
    selectedNumber(vocaloidId) {
      return this.selectedVocaloidIds.indexOf(vocaloidId) + 1
    },
    onNextClicked() {
      window.sessionStorage.setItem('vocaloids', JSON.stringify(this.selectedVocaloids))
      this.$emit('item-to-be-deleted', this.itemToBeDeleted)
      this.$emit('selected-vocaloid', this.selectedVocaloids)
    },
  },
}
</script>

<style scoped>
a.disabled {
  pointer-events: none;
}
.artist-list__item.overlay:before {
  background: rgba(0,0,0,0.6);
  position: absolute;
  z-index: 99;
  content: "";
  width: 100%;
  height: 100%;
}
.overlay-text {
  color: #fff;
  position: absolute;
  z-index: 9999;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  width: 108px;
}
.artist-list{
  margin-top: 2rem;
}
</style>
